export class CalculateVehicle {
  category: string;

  constructor(category: string) {
    this.category = category;
  }
}
